import { render, staticRenderFns } from "./ProductDetailsContainer.vue?vue&type=template&id=09be4dee&scoped=true&lang=html&"
import script from "./ProductDetailsContainer.vue?vue&type=script&lang=ts&"
export * from "./ProductDetailsContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09be4dee",
  null
  
)

export default component.exports